import { Button, Dropdown, ScrollArea, TabsList, TabsTrigger } from '@ibsys/kit';
import { ChevronDownIcon } from 'lucide-react';
import { FC, useMemo } from 'react';
import { TruncatedText, useMainLayout } from '@/shared/ui';

type TabOption = {
  key: string;
  title: string;
};

type Props = {
  options: TabOption[];
  value: string;
  onValueChange?: (value: string) => void;
};

export const DialogDataTabNav: FC<Props> = ({ options, value, onValueChange }) => {
  const { isMobile } = useMainLayout();

  const dropdownOptions = useMemo(
    () =>
      options.map((opt) => ({
        type: 'item' as const,
        key: opt.key,
        title: opt.title,
        variant: opt.key === value ? ('active' as const) : ('default' as const),
        onClick: () => onValueChange?.(opt.key),
      })),
    [options, value, onValueChange],
  );

  const currentLabel = options.find((opt) => opt.key === value)?.title ?? '';

  if (isMobile) {
    return (
      <Dropdown options={dropdownOptions}>
        <Button variant="ghost" size="sm" className="min-w-0 max-w-full">
          <TruncatedText>{currentLabel}</TruncatedText>
          <ChevronDownIcon className="size-4 shrink-0" />
        </Button>
      </Dropdown>
    );
  }

  return (
    <TabsList className="overflow-hidden">
      <ScrollArea orientation="horizontal" classNames={{ horizontalBar: 'h-1.5' }}>
        <div className="flex gap-1.5 pb-1.5">
          {options.map((opt) => (
            <TabsTrigger key={opt.key} value={opt.key}>
              {opt.title}
            </TabsTrigger>
          ))}
        </div>
      </ScrollArea>
    </TabsList>
  );
};
